module.exports = __webpack_public_path__ + "static/media/ex14.efdea9b8.jpg";